export default __webpack_public_path__ + "static/media/1.1ee59b29.jpg";